module.exports = __webpack_public_path__ + "img/logo-branco-amorsaude.7a777720.svg";